<template>
    <b-row v-if="licitacoesCarregadas" class="ml-1 d-flex align-items-start w-100">
        <b-col cols="6">
            <b-row class="d-flex align-items-start">
                <b-col cols="12">
                    <default-form-validation-provider label="Licitação" v-slot="defaultState" tag="div">
                        <div id="licitacaoSelectWrapper" class="wrapper-multiselect-sagres"
                            :class="{ 'invalid': licitacaoSelecionada.IdLicitacao === null, 'valid': licitacaoSelecionada.IdLicitacao !== null }">
                            <multiselect v-model="licitacaoSelecionada" close-on-select searchable
                                :show-labels="false" label="Descricao" deselect-label="" :allow-empty="true"
                                placeholder="Selecione" track-by="IdLicitacao" :options="listaLicitacoes"
                                class="w-100" :disabled="!listaLicitacoes" :state="defaultState.state" @input="procedimentoOrigemAtualizado">
                                <template slot="noOptions">
                                    <small><i>Nenhuma licitação cadastrada</i></small>
                                </template>
                                <template slot="noResult">
                                    <i>Nenhuma licitação encontrada</i>
                                </template>
                            </multiselect>
                        </div>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import contratoService from '@/services/licitacoes/contratoService'
import Multiselect from 'vue-multiselect'

const CompProps = Vue.extend({
    name: 'EditarProcedimentoOrigemDispensaLicitacaoPropria',
    components: { DefaultFormValidationProvider, Multiselect },
    props: {
        ctr: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class EditarProcedimentoOrigemLicitacaoPropria extends mixins(UtilsTS, CompProps) {
    contrato: Contrato = new Contrato()
    listaLicitacoes: any[] | null = null
    licitacaoSelecionada: any
    licitacoesCarregadas = false

    async mounted() {
        try {
            store.blockScreen = true
            this.contrato = this.ctr
            const responseLicitacoes = await contratoService.listarLicitacoesUG();
            this.listaLicitacoes = [{ IdLicitacao: null, Descricao: 'SELECIONE' }, ...responseLicitacoes.data]
            this.licitacaoSelecionada = this.contrato.IdLicitacao > 0 && this.contrato.FlTipoProcedOrigem === "P" ? this.listaLicitacoes.filter(l => l.IdLicitacao === this.contrato.IdLicitacao) : { IdLicitacao: null }
            this.licitacoesCarregadas = true
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarProcedimentoOrigemLicitacaoPropria', e)
        } finally {
            store.blockScreen = false
        }
    }

    procedimentoOrigemAtualizado() {
        this.contrato.IdLicitacao = this.licitacaoSelecionada.IdLicitacao
        this.$emit('input', this.contrato)
    }
}


</script>

<style scoped>
    :deep(svg) {
        padding-bottom: 0.75em;
    }

    :deep(#licitacaoSelectWrapper.invalid .multiselect__tags) {
        border: #dc3545 solid 1px !important;
        border-radius: 3px !important;
    }

    :deep(#licitacaoSelectWrapper.valid .multiselect__tags) {
        border: #28a745 solid 1px !important;
        border-radius: 3px !important;
    }

    :deep(#licitacaoSelectWrapper label) {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }
</style>